import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { AddPhotoSvg } from './svg/addPhoto';

export const AddPhotoIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AddPhotoSvg} {...props} />
);
